<template>
    <div>
        <line-chart v-if="!isLoading" :data="chartData" style="max-height: 500px" />
        <v-skeleton-loader v-else type="card" />
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import LineChart from '@/components/supplier/LineChart.vue'

    @Component({
        components: {
            LineChart,
        },
    })
    export class DetailedSalesMonitoringReport extends Vue {
        @Prop() selectedProduct
        @Prop() selectedDate

        isLoading = true
        productStatistics = null
        chartData = null

        mounted() {
            this.load()
        }

        async load() {
            try {
                this.isLoading = true

                this.productStatistics = (
                    await this.$api.detailedSalesMonitoringReport.get({
                        serviceDate: this.selectedDate,
                        productId: this.selectedProduct.productId,
                    })
                )?.productStatistics

                const totalAllocatedQuantity = this.selectedProduct.itemsByDate.find(
                    date => this.$dateFns.format(date.date) === this.selectedDate
                ).totalAllocatedQuantity
                const data = this.productStatistics.reduce(
                    (count, el) => {
                        count[0].push(el.productSalesQuantity)
                        count[1].push(totalAllocatedQuantity)

                        return count
                    },
                    [[], []]
                )
                const dates = this.productStatistics?.reduce((dates, el) => {
                    dates.push(this.$filters.dateFormat(el.salesDate))

                    return dates
                }, [])

                if (dates?.length === 1) {
                    dates.push(this.$filters.dateFormat(new Date()))
                    data[0].push(data[0][0])
                    data[1].push(totalAllocatedQuantity)
                }

                this.chartData = {
                    labels: dates,
                    datasets: [
                        {
                            label: this.selectedProduct.productName,
                            backgroundColor: '#f87979',
                            borderColor: '#1976d2',
                            data: data[0],
                            fill: false,
                        },
                    ],
                }

                if (totalAllocatedQuantity) {
                    this.chartData.datasets.push({
                        label: this.$t('total_allocated_quantity'),
                        backgroundColor: '#f87979',
                        borderColor: 'green',
                        data: data[1],
                        fill: false,
                    })
                }

                // eslint-disable-next-line no-empty
            } catch (e) {
            } finally {
                this.isLoading = false
            }
        }
    }

    export default DetailedSalesMonitoringReport
</script>
